import React, { FC, useMemo } from 'react';

import { Routes } from 'src/explore/services/Routes';

import routeToExplore from './services/routeToExplore';

import styles from './index.module.sass';

interface RestrictionsProps {
  step: number;
}

const Restrictions: FC<RestrictionsProps> = ({ step }) => {
  const termsHref = useMemo(() => routeToExplore( Routes.terms()), []);

  return step === 1 ? (
    <p className={styles.text}>
      {'Restrictions '}
      <a
        className={styles.link}
        href={Routes.help.firstOrderPromotionWhitelabel()}
        rel="noreferrer"
        target="_blank"
      >
        apply
      </a>
      {'. See '}
      <a className={styles.link} href={termsHref} rel="noreferrer" target="_blank">
        terms
      </a>
      .
    </p>
  ) : (
    <p className={`${styles.consent} ${styles.text}`}>
      {
        'By submitting this form, you agree to receive recurring automated promotional and personalized marketing text messages (e.g. cart reminders) from Goldbelly at the cell number used when signing up. Consent is not a condition of any purchase. Reply HELP for help and STOP to cancel. MSG frequency varies. Msg and data rates may apply. View '
      }
      <a className={styles.link} href={termsHref} rel="noreferrer" target="_blank">
        Terms &amp; Privacy
      </a>
      .
    </p>
  );
};

export default Restrictions;
